<template>
  <div>
    <div style="margin-bottom: 16px;">
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
      >
        <el-table-column property="createTime" label="创建时间"/>
        <el-table-column property="sort" label="分类"></el-table-column>
        <el-table-column property="" label="操作">
          <template #default="scope">
            <el-button type="primary" size="small" @click="addSort(scope.$index, scope.row)" >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
<!--      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--      </el-pagination>-->
    </div>
    <el-button type="primary" @click="addSort(-1)" >添加</el-button>
  </div>
</template>

<script>
import {getAdviceListSort } from '@/api/url'
import { getFormData } from '@/api/api'
import Dialog from "@/assets/js/dialog";
import addOrEditSortDialog from "@/views/feedback/components/addOrEditSortDialog";

export default {
  name: "ListSortDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      // param['pageNum'] = page;
      // param['userId'] = this.userId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAdviceListSort, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          // this.totalRow = result['total'];
          // this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    addSort(idx, row) {
      let _title = '';
      let sortForm = {}
      if (idx > -1) {
        _title = '编辑分类'
        sortForm = Object.assign({}, row);
      }else {
        _title = '新建分类'
      }
      Dialog.open({
        title: _title,
        component: addOrEditSortDialog,
        data: {
          sortForm: sortForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          if(result.id == 0) {
            this.getPage()
          } else {
            row['sort'] = result.sort
          }
        }
      })
    },




  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
